import { render, staticRenderFns } from "./EditReference.vue?vue&type=template&id=083c2c84"
import script from "./EditReference.vue?vue&type=script&lang=js"
export * from "./EditReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports